import React, { Component } from "react";
import "./PoliciesCreatePage.css";
import Header from "../../components/Header/Header";
import Navigation from "../../components/Navigation/Navigation";
import TransportStep from "./steps/TransportStep/TransportStep";
import InsurerStep from "./steps/InsurerStep/InsurerStep";
import ViewStep from "./steps/ViewStep/ViewStep";
import PaymentStep from "./steps/PaymentStep/PaymentStep";
import classnames from "classnames";
import { connect } from "react-redux";
import { getFormValues, change, reset } from "redux-form";
import api from "../../api/index";
import uuId from "uuid/v4";
import { mapToOptionsCategory } from "../../utils/index";
import EndStep from "./steps/EndStep/EndStep";
import Footer from "../../components/Footer/Footer";
import * as moment from "moment";
import { getTranslate } from "react-localize-redux";
import PolicyStep from "./steps/PolicyStep/PolicyStep";
import FaEye from "react-icons/lib/fa/eye";
import FaTick from "react-icons/lib/fa/calendar-check-o";
import FaFileTextO from "react-icons/lib/fa/file-text-o";
import Guy from "../../components/Svgs/Man";
import { FaAutomobile, FaCreditCard } from "react-icons/lib/fa/index";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class PoliciesCreatePage extends Component {
  constructor(props) {
    toast.configure();
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      step: 1,
      fillStep: 1,
      policyAggregateId: "",
      aggregateId: "",
      isPaying: false,
      paymentStatus: "",
      paymentPoliciesId: "",
      vehicleDriverType: "I",
      ecommerceList: [],
      selectedBank: null,
      visitorId: "",
      fraudMessage: "",
    };
    this.bankType = {
      0: "liberty",
      1: "bog",
      2: "payfy",
    };
  }

  getEcommerceList = () => {
    // const data = {
    // 	ecommerceConfiguration: [
    // 	  {
    // 		cardProcessingFee: 1.0,
    // 		foreignCardProcessingFee: 1.1,
    // 		bank: 0
    // 	  },
    // 	  {
    // 		cardProcessingFee: 2.0,
    // 		foreignCardProcessingFee: 2.2,
    // 		bank: 1
    // 	  }
    // 	]
    //   };
    //   this.setState({ecommerceList: data.ecommerceConfiguration})
    api.ecommerce.getEcommerceList().then((response) => {
      if (response["status"] === 200) {
        const list = response.data.data.ecommerceConfiguration;
        if (list && list.length === 1) {
          this.setState({ selectedBank: list[0].bank });
        }
        this.setState({ ecommerceList: list });
      }
    });
  };

  getFraudMessage = () => {
    api.policy
      .getFraudMessage(
        window.location.pathname.substring(1, 3).toLocaleLowerCase()
      )
      .then((data) => {
        this.setState({ fraudMessage: data.data });
      })
      .then(() => this.createNotification());
  };

  createNotification() {
    toast.error(this.state.fraudMessage, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: false,
      newestOnTop: false,
      rtl: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      style: { marginBottom: "60px" }
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.dispatch(change("CreatePolicyForm", "insurerType", "I"));
    this.props.dispatch(change("CreatePolicyForm", "vehicleOwnerType", "I"));
    this.props.dispatch(
      change("CreatePolicyForm", "driverAndInsurerIdentity", "Y")
    );
    this.props.dispatch(
      change("CreatePolicyForm", "ownerAndInsurerIdentity", "Y")
    );

    if (this.props.match.params.status) {
      this.setState({
        paymentStatus: this.props.match.params.status,
        paymentPoliciesId: this.props.match.params.policiesId,
        step: 6,
      });
    }

    this.setState({
      policyAggregateId: uuId(),
    });

    this.props.dispatch(
      change("CreatePolicyForm", "vehicleIdentificationType", "1")
    );

    this.getEcommerceList();
  }

  handleSelectedBank = (val) => {
    this.setState({ selectedBank: val });
  };

  componentWillUnmount() {
    this.props.dispatch(reset("CreatePolicyForm"));
  }

  nextPage() {
    this.setState({ step: this.state.step + 1 });
    this.setState({ fillStep: this.state.fillStep + 1 });
  }
  previousPage() {
    this.setState({ step: this.state.step - 1 });
  }

  checkVisitorId = () => {
    // Initialize an agent at application startup.
    const fpPromise = FingerprintJS.load({
      token: window.config.env.FINGERPRINT_TOKEN,
    });
    // Get the visitor identifier when you need it.
    fpPromise
      .then((fp) => fp.get())
      .then((result) => this.setState({ visitorId: result.visitorId }));
    this.nextPage();
  };

  registrationPolicy = () => {
    let values = this.props.policyFields;
    let ob = {
      uId: this.state.policyAggregateId,
      startDate: values.startDate.format("YYYY-MM-DD"),
      vinCode: values.vinCode ? values.vinCode.toUpperCase() : "",
      frameNumber: values.chassisNumber
        ? values.chassisNumber.toUpperCase()
        : "",
      vehicleCategoryId: values.vehicleCategoryId,
      vehicleRegistrationNumber: values.vehicleRegistrationNumber.toUpperCase(),
      vehicleManufacturerId: values.vehicleManufacturerNumber,
      vehicleModelId: values.vehicleModelId,
      insurerType: values.insurerType,
      insurerTitle: values.insurerTitle,
      insurerIdentificationNumber: values.insurerIdentificationNumber,
      insurerEmail: values.insurerEmail,
      insurerPhone: values.insurerPhone,
      insurerCitizenshipId: values.insurerCitizenshipId,
      vehicleManufacturerName: values.vehicleManufacturerName,
      vehicleModelName: values.vehicleModelName,
      vehicleOwnerType: values.vehicleOwnerType,
      vehicleOwnerTitle: values.vehicleOwnerTitle,
      vehicleOwnerIdentificationNumber: values.vehicleOwnerIdentificationNumber,
      vehicleOwnerEmail: values.vehicleOwnerEmail,
      vehicleOwnerPhone: values.vehicleOwnerPhone,
      vehicleOwnerCitizenshipId: values.vehicleOwnerCitizenshipId,
      vehicleDriverType: this.state.vehicleDriverType,
      vehicleDriverTitle: values.vehicleDriverTitle,
      vehicleDriverIdentificationNumber: values.vehicleDriverIdentificationNumber,
      vehicleDriverEmail: values.vehicleDriverEmail,
      vehicleDriverPhone: values.vehicleDriverPhoneNumber,
      vehicleDriverCitizenshipId: values.vehicleDriverCitizenshipId,
      productId: values.issueDate,
      borderCrossId: null,
      lang: window.location.pathname.substring(1, 3).toLocaleLowerCase(),
      visitorId: this.state.visitorId,
    };
    this.setState({ isPaying: true });

    api.policy
      .create(ob)
      .then((response) => {
        if (response["status"] === 200) {
          let paymentOb = {
            policyUId: this.state.policyAggregateId,
            paymentType: "O",
            payerTitle: values.insurerTitle,
            payerIdentificationNumber: values.insurerIdentificationNumber,
          };
          window.location.assign(
            `${window.config.env.ECOMMERCE_SERVICE}/ecommerce/${this.bankType[this.state.selectedBank]}` +
            "?lang=" +
            localStorage.getItem("currentLanguage") + '&' + new URLSearchParams(paymentOb).toString()
          );
        }
      })
      .catch(() => {
        this.getFraudMessage();
      });
  };

  onBackPolicy = () => {
    api.policy.getPolicy(this.state.paymentPoliciesId).then(({ data }) => {
      this.props.dispatch(change("CreatePolicyForm", "vinCode", data.vinCode));
      this.props.dispatch(
        change("CreatePolicyForm", "chassisNumber", data.chassisNumber)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleCategoryName", data.vehicleCategory)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleCategoryId", data.vehicleCategoryId)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleRegistrationNumber",
          data.vehicleRegistrationNumber
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleManufacturerNumber",
          data.vehicleManufacturerId
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleManufacturerName",
          data.vehicleManufacturer
        )
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleModelName", data.vehicleModel)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleModelId", data.vehicleModelID)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "issueDate", data.productId)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "endDate",
          moment(data.endDate).format("DD/MM/YYYY")
        )
      );
      this.props.dispatch(change("CreatePolicyForm", "premium", data.premium));

      this.props.dispatch(
        change("CreatePolicyForm", "insurerType", data.insurerType)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "insurerName", data.insurerName)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "insurerLastname", data.insurerLastname)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "insurerIdentificationNumber",
          data.insurerIdentificationNumber
        )
      );
      this.props.dispatch(
        change("CreatePolicyForm", "insurerEmail", data.insurerEmail)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "insurerPhone", data.insurerPhone)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "insurerCitizenshipId",
          data.insurerCitizenshipId
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "insurerCitizenshipName",
          data.insurerCitizenship
        )
      );

      this.props.dispatch(
        change("CreatePolicyForm", "vehicleOwnerType", data.vehicleOwnerType)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleOwnerName", data.vehicleOwnerName)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleOwnerLastname",
          data.vehicleOwnerLastname
        )
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleOwnerTitle", data.vehicleOwnerTitle)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleOwnerIdentificationNumber",
          data.vehicleOwnerIdentificationNumber
        )
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleOwnerEmail", data.vehicleOwnerEmail)
      );
      this.props.dispatch(
        change("CreatePolicyForm", "vehicleOwnerPhone", data.vehicleOwnerPhone)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleOwnerCitizenshipId",
          data.vehicleOwnerCitizenshipId
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleOwnerCitizenshipName",
          data.vehicleOwnerCitizenship
        )
      );

      this.props.dispatch(
        change("CreatePolicyForm", "vehicleDriverName", data.vehicleDriverName)
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverLastname",
          data.vehicleDriverLastname
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverIdentificationNumber",
          data.vehicleDriverIdentificationNumber
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverEmail",
          data.vehicleDriverEmail
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverPhoneNumber",
          data.vehicleDriverPhone
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverCitizenshipId",
          data.vehicleDriverCitizenshipId
        )
      );
      this.props.dispatch(
        change(
          "CreatePolicyForm",
          "vehicleDriverCitizenshipName",
          data.vehicleDriverCitizenship
        )
      );

      this.setState({
        step: 3,
      });
    });
  };

  handleStepChange = (step) => {
    if (step < this.state.fillStep) {
      this.setState({ step });
    }
  };

  render() {
    const { translate } = this.props;
    const { ecommerceList, selectedBank } = this.state;
    return (
      <div className="main">
        <div className="Head">
          <Header />
          <Navigation />
          <div className="policy-breadcrumbs" id="breadcrumbs">
            <ul className="breadcrumbs-container">
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(1);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 1,
                      "step-success": this.state.step > 1,
                    })}
                  >
                    <FaFileTextO
                      className={classnames("step-icon", {
                        "step-active-icon": this.state.step >= 1,
                      })}
                    />
                  </span>
                  <p>{translate("policy")}</p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(2);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 2,
                      "step-success": this.state.step > 2,
                    })}
                  >
                    <FaAutomobile
                      className={classnames("step-icon", {
                        "step-active-icon": this.state.step >= 2,
                      })}
                    />
                  </span>
                  <p>{translate("car")} </p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(3);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 3,
                      "step-success": this.state.step > 3,
                    })}
                  >
                    {this.state.step >= 3 && <Guy fill="#0C444A" />}
                    {this.state.step < 3 && <Guy fill="#ffffff" />}
                  </span>
                  <p>{translate("insurer")}</p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(4);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 4,
                      "step-active-payment-error":
                        this.state.step === 4 &&
                        this.state.paymentStatus === "error",
                      "step-success": this.state.step > 4,
                    })}
                  >
                    <FaEye
                      className={classnames("step-icon", {
                        "step-active-icon": this.state.step >= 4,
                      })}
                    />
                  </span>
                  <p>{translate("view")}</p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(5);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 5,
                      "step-active-payment-error":
                        this.state.step === 6 &&
                        this.state.paymentStatus === "error",
                      "step-success": this.state.step > 5,
                    })}
                  >
                    <FaCreditCard
                      className={classnames("step-icon", {
                        "step-active-icon": this.state.step >= 5,
                      })}
                    />
                  </span>
                  <p>{translate("payment")}</p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    this.handleStepChange(6);
                  }}
                >
                  <span
                    className={classnames({
                      "step-active": this.state.step === 6,
                      "step-active-payment-error":
                        this.state.step === 5 &&
                        this.state.paymentStatus === "error",
                    })}
                  >
                    <FaTick
                      className={classnames("step-icon", {
                        "step-active-icon": this.state.step >= 6,
                      })}
                    />
                  </span>
                  <p>{translate("end")}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        {this.state.step === 1 && (
          <PolicyStep
            categoriesSelect={this.props.categoriesSelect}
            categories={this.props.categories}
            onSubmit={this.nextPage}
          />
        )}
        {this.state.step === 2 && (
          <TransportStep
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
            categoriesSelect={this.props.categoriesSelect}
            categories={this.props.categories}
          />
        )}
        {this.state.step === 3 && (
          <InsurerStep
            previousPage={this.previousPage}
            onSubmit={this.checkVisitorId}
            categoriesSelect={this.props.categoriesSelect}
            categories={this.props.categories}
          />
        )}
        {this.state.step === 4 && (
          <ViewStep
            previousPage={this.previousPage}
            isPaying={this.state.isPaying}
            onClick={this.nextPage}
            ecommerceList={ecommerceList}
            selectedBank={selectedBank}
            handleSelectedBank={this.handleSelectedBank}
            bankType={this.bankType}
          />
        )}
        {this.state.step === 5 && (
          <PaymentStep
            previousPage={this.previousPage}
            isPaying={this.state.isPaying}
            onClick={this.registrationPolicy}
            ecommerceList={ecommerceList}
            selectedBank={selectedBank}
            handleSelectedBank={this.handleSelectedBank}
            bankType={this.bankType}
          />
        )}
        {this.state.step === 6 && (
          <EndStep
            status={this.state.paymentStatus}
            policyId={this.state.paymentPoliciesId}
            aggregateId={this.state.aggregateId}
            onChange={this.onBackPolicy}
          />
        )}
        <ToastContainer />
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  categoriesSelect: mapToOptionsCategory(state.categories),
  categories: state.categories,
  policyFields: getFormValues("CreatePolicyForm")(state),
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(PoliciesCreatePage);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/PoliciesCreatePage.js